import { Component, OnInit, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { MonitoringService } from '@nha/monitoring';

@Component({
	selector: 'at-root',
	templateUrl: './attendance.component.html',
	styleUrls: ['./attendance.component.scss'],
	imports: [RouterOutlet]
})
export class AttendanceComponent implements OnInit {
	private _matIconRegistry = inject(MatIconRegistry);
	private _domSanitizer = inject(DomSanitizer);

	constructor() {
		const monitoringService = inject(MonitoringService);

		monitoringService.init('Attendance_UI');
	}

	ngOnInit(): void {
		this._matIconRegistry.addSvgIcon('attendance_calendar', this._domSanitizer.bypassSecurityTrustResourceUrl('assets/calendar.svg'));
	}
}
